import { TRACKING } from "../../../constants/tracking";

export const TrackingServiceImplFactory: ITrackingService = ({
  trackingRepository,
}) => {
  return {
    track: async (payload) => {
      try {
        const response = await trackingRepository.track({
          ...payload,
          application: TRACKING.APPLICATION.CIP,
        });
        return {
          success: true,
          data: response,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    },
  };
};
